import React from 'react';

// Components
import WarningModal from './WarningModal';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  backdropClassName?: string;
  riskProfileLabel: string;
  show?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const DiscardPortfolioRiskProfileModal = ({ riskProfileLabel, show, onCancel, onConfirm, ...rest }: Props) => {
  const body = <p>{formatMessage('DiscardPortfolioRiskProfile.Body', { riskProfile: riskProfileLabel })}</p>;

  return (
    <WarningModal body={body} onCancel={onCancel} onConfirm={onConfirm} show={show} title={formatMessage('DiscardPortfolioRiskProfile.Title')} {...rest} />
  );
};

export default DiscardPortfolioRiskProfileModal;
